<div class="message-bubble" *ngIf="message()" [ngClass]="setClasses(message())">
  @if(message().author || message().custom_class){
    <div class="message-author">{{ message().author?.name || message().custom_class }}</div>
  }
  @if(!quote()){
    @if(message().reply){
      <app-chat-bubble [message]="message().reply" [quote]="true" class="message-reply"></app-chat-bubble>  
    }
    @if (message().document_id) {
      <div
          class="document-details" 
      >
        <div class="document-name">
          <div class="message-icon">
            <mat-icon>attach_file</mat-icon>
          </div>
          @if (message().document){
            <div
              class="message-title link"
              (click)="goToDocumentChat(message().document_id)"
            >
              {{ message().document_type | human }} #{{ message().document?.correlative_id || message().document_id }}
            </div>
          }
          @else {
            <div
                class="message-title link"
            >
              <div style="display: flex; align-items: center; gap: 5px;">
                Creando {{ message().document_type | human }} <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
              </div>
            </div>
          }
        </div>
        @if(message().document){
          <!--<app-chat-detail [compactChat]="{
              document_id: message().document_id,
              document_type: message().document_type,
            }"></app-chat-detail>-->
        }
      </div>
    }

    @if(message().calendar_event){
      <div class="event-details">
        <div class="event-name">
          <div class="message-icon">
            <mat-icon>calendar_month</mat-icon>
          </div>
          <div class="message-title">
            {{ message().calendar_event.name }}
          </div>
        </div>
        <div class="event-date">
          <b>Hora y Fecha:</b> {{ message().calendar_event.start_date | date: 'fullDate' }} a las {{ message().calendar_event.start_date | date: 'shortTime' }}
        </div>
        <div class="event-duration">
          <b>Duración:</b> {{ message().calendar_event.duration }} hora(s)
        </div>
        <div class="event-duration">
          <b>Creado por:</b> {{ message().author.name }}
        </div>
      </div>
    }
    @if(!message().deleted_at && message().pictures?.length > 0 || message().upload?.length > 0){
      <app-image-uploader [photos]="message().pictures"
        [uploadImages]="message().upload"
        [readonly]="true"
        [chat]="true"
        (uploaded)="addPhotos($event)"
        [hidden]="!!message().document_type"
      ></app-image-uploader>
    }
  }
  <div class="message-text" [class.no-comment]="!message().comment" [class.deleted]="message().deleted_at" [class.padding-top]="hasAttachments(message())">
    @if(quote()){
      @if(message().pictures?.length >0){
        <div class="message-icon">
          <mat-icon>image</mat-icon>
        </div>
      }
      @if(message().calendar_event){
        <div class="message-icon">
          <mat-icon>calendar_month</mat-icon>
        </div>
        <div class="message-title">{{ message().calendar_event.name }}
          <div class="message-subtitle">
            {{ message().calendar_event.start_date | date }} - {{ message().calendar_event.start_date | date: 'shortTime' }}
          </div>
        </div>
      }
      @if(!message().calendar_event){
        @if(message().comment && message().comment.length > 0){
          <div class="message-body" [innerHTML]="(!message().deleted_at ? message() : '') | message:false:100"></div>
        }
        @else if (message().deleted_at){
          <div class="message-body">
            <i>Mensaje eliminado</i>
          </div>
        }
        @else{
          <div class="message-body">
            <i>Sin comentario</i>
          </div>
        }
      }
    }
    @else{
      @if(message().comment && message().comment.length > 0){
        <div class="message-body">
          @if(message().target_type =='Client'){
            <div class="message-icon">
              <mat-icon>person</mat-icon>
            </div>
          }
          <span [innerHTML]="(!message().deleted_at ? message() : '') | message"></span>
          @if(message().id){
            <mat-icon *ngIf="message().isOwn" class="check">check</mat-icon>
          }@else{
            <mat-icon *ngIf="message().isOwn" class="check">access_time</mat-icon>
          }
        </div>
      }
      @else if (message().deleted_at){
        <div class="message-body">
          <i>Mensaje eliminado</i>
        </div>
      }
    }
  </div>
  @if(!quote()){
    <div class="timestamp">
      {{ message().created_at | date: isToday(message().created_at) ? 'shortTime' : 'short' }}
      @if(message().work_instance){
        <span class="work-instance" (click)="openWork(message().work_instance.id)">
          @if(message().work_instance.work){
            <span class="work-name">&#64;{{ message().work_instance.work.name | truncate: ['15'] }}</span>
          }
        </span>
      }
    </div>
  }
</div>
<ng-content></ng-content>